<div
    class="border border-solid border-dat-grey-100 rounded px-4 py-2"
>
    <iq-table-rate-shared
        [id]="id()"
        [headerRow]="headerRow()"
        [rows]="sortedRows() | async"
        (headerClicked)="updateSort($event)"
        [numOfRows]="35"
    ></iq-table-rate-shared>
</div>
